import React from 'react';
import PageBanner from '../components/PageBanner';
import FindUs from '../components/sections/FindUs';

const Contact = () => {
  return (
    <>
      <PageBanner title="Contact Us" subtitle="Looking to arrange care or find qualified staff? Reach out for a free, friendly first chat." crumb="Contact Us" variant="contact" image="/generated/welcome-main.png" />
      <FindUs />
    </>
  );
};

export default Contact;
